// Deprecated -- use currency normalizer
import React from 'react'
import { formatFloatNumber, getCurrencySeparators } from '../utils/currencyUtils'

const Currency = ({ value, code, symbol }) => (
  <span>
    {(!!code || !!symbol) && <small>{code || symbol}</small>}{' '}
    <span>{formatFloatNumber({ value: value / 100, separators: getCurrencySeparators({ code, symbol }) })}</span>
  </span>
)

export default Currency
